import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import editIcon from "../../../assests/bosEdit.svg";
import deleteIcon from "../../../assests/deleteIcon.svg";
import { ArrowLeft } from "lucide-react";
import './SubCategoryList.css';

const SubCategoryListComponent = ({
  subCategories = [],
  category,
  loading,
  searchTerm,
  onSearch,
  onAddSubCategory,
  onEditSubCategory,
  onDeleteSubCategory,
  onSubCategoryClick,
  onBack,
  onRefresh,
  onViewAttributes,
}) => {
  const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";

  const getStatusDisplay = (status) => {
    if (status === true) return "ACTIVE";
    return "INACTIVE";
  };

  const getStatusClass = (status) => {
    if (status === true) return "sub-status-active";
    return "sub-status-inactive";
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = DEFAULT_IMAGE;
  };

  if (loading) {
    return (
      <div className="subcategory-container">
        <Sidebar />
        <div className="subcategory-content">
          <div className="full-page-loader">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="subcategory-container">
        <Sidebar />
        <div className="subcategory-content">
          <div className="error-state">
            <p>Category not found</p>
            <button onClick={onBack}>Go Back</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="subcategory-container">
      <Sidebar />
      
      <div className="subcategory-content">
        {/* Header */}
        <div className="subcategory-header">
          <button className="subcategory-back-btn" onClick={onBack}>
            <ArrowLeft size={20} />
          </button>
          <div className="subcategory-header-info">
            <h1>Sub Categories</h1>
            <div className="parent-category-badge">
              Parent Category: {category.name || category.categoryName}
            </div>
          </div>
          <button 
            className="subcategory-view-attributes-btn" 
            onClick={onViewAttributes}
            type="button"
          >
            View Category Level Attributes
          </button>
        </div>

        {/* Search Section */}
        <div className="subcategory-search-section">
          <div className="sub-search-wrapper">
            {/* <svg className="sub-search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg> */}
            <input
              type="text"
              placeholder="Search sub categories..."
              value={searchTerm}
              onChange={(e) => onSearch(e.target.value)}
              className="sub-search-input"
            />
            {searchTerm && (
              <button 
                className="sub-search-clear"
                onClick={() => onSearch("")}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* Sub Categories Grid Wrapper */}
        <div className="subcategory-grid-wrapper">
          <div className="subcategory-grid">
            {/* Create New Sub Category Card */}
            <div 
              className="subcategory-card create-card"
              onClick={onAddSubCategory}
            >
              <div className="create-card-content">
                <div className="plus-icon-wrapper">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </div>
                <div className="create-card-text">Create New Sub Category</div>
              </div>
            </div>

            {/* Existing Sub Categories */}
            {subCategories.length === 0 ? (
              <div className="no-subcategories">
                <div className="no-data-icon">📦</div>
                <p>No sub categories found</p>
                <small>Create a new sub category to get started</small>
              </div>
            ) : (
              subCategories.map((subCategory) => {
                const isInactive = subCategory.active === false;
                
                return (
                  <div 
                    key={subCategory.id} 
                    className={`subcategory-card ${isInactive ? 'inactive-card' : ''}`}
                    onClick={() => onSubCategoryClick(subCategory)}
                  >
                    {/* Status Badge */}
                   

                    {/* Action Buttons */}
                    <div className="subcategory-card-actions">
                      <button 
                        className="action-icon edit-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          onEditSubCategory(subCategory);
                        }}
                        title="Edit Sub Category"
                      >
                        <img src={editIcon} alt="Edit" />
                      </button>
                      {/* {onDeleteSubCategory && (
                        <button 
                          className="action-icon delete-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteSubCategory(subCategory);
                          }}
                          title="Delete Sub Category"
                        >
                          <img src={deleteIcon} alt="Delete" />
                        </button>
                      )} */}
                    </div>

                    {/* Sub Category Image */}
                    <div className="subcategory-card-image">
                      <img 
                        src={subCategory.image || subCategory.image_url || DEFAULT_IMAGE} 
                        alt={subCategory.name}
                        onError={handleImageError}
                      />
                    </div>

                    {/* Sub Category Name */}
                    <div className="subcategory-card-name">
                      <div style={{marginBottom:"10px"}}>  {subCategory.name}</div>

                     
                       <div className={`sub-status-badge ${getStatusClass(subCategory.active)}`}>
                      {getStatusDisplay(subCategory.active)}
                    </div>
                    </div>
                    
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryListComponent;